import { sumBy } from 'lodash';
import * as React from 'react';

import { AdminUpgradeStats } from 'admin/components/AdminUpgradeStats';
// @ts-ignore
import remindWwwRequest from 'lib/remindWwwRequest';

type Props = {
  onNoStats: () => void;
  organizationUuid: string;
};

export type School = {
  messaging_users_count: number;
  org_name: string;
  school_pages_equivalent_grade: 'high_school' | 'not_high_school';
};

type CommunicationStats = {
  announcements: number;
  conversations: number;
  date: string;
};

type ReachStats = {
  date: string;
  parents: number;
  students: number;
  teachers: number;
};

export type Stats = {
  communication_usage: {
    chart: Array<CommunicationStats>;
  };
  reach_usage: {
    chart: Array<ReachStats>;
  };
};

type State = {
  school?: School;
  stats?: Stats;
};

export default class AdminUpgradeStatsContainer extends React.Component<Props, State> {
  state: State = {
    school: undefined,
    stats: undefined,
  };

  componentDidMount() {
    this.getProfile();
    this.getStats();
  }

  getProfile = () => {
    const onSuccess = (response: School) => {
      if (!response) {
        this.handleNoStats();
        return;
      }

      this.setState({ school: response });
    };

    const onError = () => {
      this.handleNoStats();
    };

    return remindWwwRequest(`/school_pages/${this.props.organizationUuid}/profile`).then(
      onSuccess,
      onError
    );
  };

  getStats = () => {
    const onSuccess = (response: Stats) => {
      if (!response) {
        this.handleNoStats();
        return;
      }

      const communicationSum = sumBy(
        response.communication_usage.chart,
        (item: CommunicationStats) => item.announcements + item.conversations
      );
      const reachSum = sumBy(
        response.reach_usage.chart,
        (item: ReachStats) => item.parents + item.students
      );

      if (!communicationSum || !reachSum) {
        this.handleNoStats();
        return;
      }

      this.setState({ stats: response });
    };

    const onError = () => {
      this.handleNoStats();
    };

    return remindWwwRequest(`/school_pages/${this.props.organizationUuid}/usage`).then(
      onSuccess,
      onError
    );
  };

  handleNoStats = () => {
    this.props.onNoStats();
  };

  render() {
    const { school, stats } = this.state;

    if (!school || !stats) {
      return null;
    }

    return <AdminUpgradeStats school={school} stats={stats} />;
  }
}
